import { createAction } from 'redux-actions'

export const setInitialLocation = createAction('SSR/SET_INITIAL_LOCATION')
